import { nextTick, onMounted, onUnmounted } from 'vue';
import { useGlobalStore } from 'src/stores/global';
import type { EeventActions } from 'src/types/HeaderActions';

type UseHeaderActionsOptions = {
  eventActions?: EeventActions[];
  title?: string;
  total?: number | undefined;
};

export function useHeaderActions(options?: UseHeaderActionsOptions) {
  const globalStore = useGlobalStore();

  onMounted(async () => {
    // Initialize title/total (fallback to clearing if not provided)
    globalStore.setTotal(options?.total ?? undefined);
    globalStore.setTitle(options?.title ?? '');
    if (!options?.eventActions || options.eventActions.length === 0) return;
    await nextTick();
    globalStore.setHeaderActions(options.eventActions);
  });

  onUnmounted(() => {
    // Clear header actions when the component using this composable is unmounted
    globalStore.setTotal(undefined);
    globalStore.setTitle('');
    globalStore.clearHeaderActions();
  });

  function updateActions(newActions: EeventActions[]) {
    globalStore.clearHeaderActions();
    globalStore.setHeaderActions(newActions);
  }

  function addAction(newAction: EeventActions) {
    globalStore.addHeaderAction(newAction);
  }

  function removeAction(action: EeventActions) {
    globalStore.removeHeaderAction(action);
  }

  function setTitle(title: string) {
    if (!title || typeof title !== 'string') return;
    globalStore.setTitle(title);
  }

  return {
    updateActions,
    addAction,
    removeAction,
    setTitle,
  };
}
